import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import Search from "@insite/mobius/Icons/Search";
import getColor from "@insite/mobius/utilities/getColor";
import { contentSpacingStyles } from "@store/theme/common/mixins";
import {
    productListFiltersSectionStyles,
    productListFiltersTitleProps,
} from "@store/theme/common/props/productListFilters";
import { css } from "styled-components";

Object.assign(searchWithinStyles, {
    wrapper: {
        css: css`
            ${productListFiltersSectionStyles(true)}
        `,
    },
    titleText: {
        ...productListFiltersTitleProps,
        css: css`
            ${contentSpacingStyles(null, "0.5em")}
        `,
    },
    searchTextField: {
        border: null,
        iconProps: { src: Search },
        cssOverrides: {
            formField: css`
                ${({ theme }) => theme.formField?.defaultProps?.cssOverrides?.formField}
                width: 100%;
            `,
            inputSelect: css`
                ${({ theme }) => theme.formField?.defaultProps?.cssOverrides?.inputSelect}
                border-color: transparent;
                background-color: ${getColor("common.accent")};
                border-radius: 2em !important; /* Set radius for all states at once */

                &::placeholder {
                    font-style: italic;
                }
            `,
        },
    },
});